import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { FINANCE_PERMISSIONS } from '@modules/finance/constants';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IFinanceDeductionPayload,
  IFinanceDeductionResponse,
} from '../types';
import {
  ADMIN_FINANCE_MONTH_DEDUCTION_URL,
  FINANCE_MONTH_DEDUCTION_QUERY_KEY,
} from '../constants';

export default function useFinanceDeductionQuery(
  payload: Ref<IFinanceDeductionPayload>,
): IContextQueryResult<IFinanceDeductionResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IFinanceDeductionResponse, Error>({
    queryKey: [FINANCE_MONTH_DEDUCTION_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchGet<IFinanceDeductionResponse>(
      ADMIN_FINANCE_MONTH_DEDUCTION_URL,
      {
        queryParams: payload.value,
        signal,
        permission: FINANCE_PERMISSIONS.DEDUCTION,
      },
    ),
    placeholderData: keepPreviousData,
    enabled: computed(() => !!payload.value.affiliate_id && !!payload.value.date_of_payment),
  });
}
